import { createContext } from "react";
import type { ModuleMountOptions } from "@opengov/psp-contract";

export const PspOptionsContext = createContext<ModuleMountOptions | null>(null);
